import { Box, CircularProgress, CircularProgressProps, TableCell, TableRow } from '@mui/material';
import React from 'react';

interface ILoadingProps extends CircularProgressProps {
  isFullWidth?: boolean;
}

export const Loading: React.FC<ILoadingProps> = ({ isFullWidth = false, ...props }) => {
  const { size = 40 } = props;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: isFullWidth ? '100%' : 'auto' }}>
      <CircularProgress size={size} />
    </Box>
  );
};

export const TableLoading: React.FC = () => {
  return (
    <TableRow key="loading">
      <TableCell colSpan={4} align="center">
        <CircularProgress />
      </TableCell>
    </TableRow>
  );
};
